<div class="datiq-cell-select">
    <mat-checkbox
        class="datiq-cell-select__checkbox"
        [checked]="settings.selected"
        [indeterminate]="settings.indeterminate"
        [disabled]="settings.disabled"
        (change)="checkboxChanged($event)"
        (click)="$event.stopPropagation()"
    ></mat-checkbox>
</div>
